import UPDomainSidebar from './UPDomainSidebar';

export default UPDomainSidebar;
